import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  FilterRow,
  StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarContaCosifDs } from "../../DataSources";
import memoria from "../../Memoria";

const localStorageKey = "cadastroContasCosifGridState";

export default class ContasCosifBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.contaCosifDs = criarContaCosifDs();
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("contascosif/editar/" + e.data.id);
  }

  componentDidMount() {
    memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="Conta Cosif"
            novoCb={this.novaContaCosif.bind(this)}
          >
            <DataGrid
              ref={grid => (this._gridInstance = grid)}
              dataSource={criarContaCosifDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              focusedRowEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <StateStoring
                enabled={true}
                type={"localStorage"}
                storageKey={localStorageKey}
              />
              <FilterRow visible={true} />

              <Editing
                allowDeleting={!this.usadoComoPesquisa}
                allowUpdating={!this.usadoComoPesquisa}
                useIcons={true}
                visible={!this.usadoComoPesquisa}
              />

              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  "edit",
                  "delete",
                  {
                    hint: "Selecionar",
                    icon: "repeat",
                    visible: this.usadoComoPesquisa,
                    onClick: this.onSelecionado,
                  },
                ]}
              />
              <Column dataField={"id"} caption={"#"} allowEditing={false} />
              <Column dataField={"codigo"} caption={"Código"} />
              <Column dataField={"descricao"} caption={"Descrição"} />
              <Column dataField={"servico"} caption={"Serviço"} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novaContaCosif() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("contascosif/novo");
  }
}
